// @flow
import { SUBMIT_RATING, TOGGLE_RATING_DLG, SET_RATING_PARAMS } from './types';
import type { Action } from './types';

export const submitRating = (data: { [key: string]: string }): Action => ({
	type: SUBMIT_RATING,
	payload: data,
});

export const toggleRatingDlg = (state: boolean): Action => ({
	type: TOGGLE_RATING_DLG,
	payload: state,
});

export const setRatingParams = (data: Object): Action => ({
	type: SET_RATING_PARAMS,
	payload: data,
});

